const input = {
    username: '사용자 이름',
    password: '비밀번호',
    email: '이메일',
    phone_number: '휴대전화번호',
    confirm_password: '비밀번호 확인',
    search_region_code: '지역 코드 검색',
    backup_code: '백업 코드',
    code: '코드',
    label_with_optional: '{{label}} (선택사항)',
    email_address: '이메일 주소',
    email_placeholder: '이메일을 입력하세요',
    enter_email: '이메일을 입력하세요',
};
export default Object.freeze(input);
